import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import PageTitle from "../elements/Pagetitle";
import Portfolio from "../elements/Portfolio";

const filters = [
  {
    id: 1,
    text: "Everything",
  },
  {
    id: 2,
    text: "Data Science",
  },
  {
    id: 3,
    text: "Cloud Architecture",
  },
  {
    id: 4,
    text: "Web3",
  },
  {
    id: 5,
    text: "Software Engineering",
  },
];

const allData = [
  {
    id: 1,
    title: "Social Media Data Scraping on IG",
    category: "Data Science",
    image: "images/works/nwd.png",
    // popupLink: ["images/works/1.svg"],
  },
  {
    id: 2,
    title: "Product Search on planogram",
    category: "Data Science",
    image: "images/works/asw.png",
  },
  {
    id: 3,
    title: "Dialogflow and Chatbot implementation",
    category: "Data Science",
    image: "images/works/vita.png",
  },
  {
    id: 4,
    title: "Speech to Text + Speaker Diarization for long recording",
    category: "Data Science",
    image: "images/works/pt.png",
  },
  {
    id: 5,
    title: "Workspace Suite Migration",
    category: "Cloud Architecture",
    image: "images/works/mcl.png",
  },
  {
    id: 6,
    title: "Marketing Page Renovation",
    category: "Software Engineering",
    image: "images/works/mf.png",
    // link: "https://dribbble.com",
  },
  {
    id: 7,
    title: "Full stack Development",
    category: "Web3",
    image: "images/works/ab.png",
    // link: "https://pinterest.com",
  },
  {
    id: 8,
    title: "Web3 Data Analysis",
    category: "Web3",
    image: "images/works/ab.png",
  },
  {
    id: 9,
    title: "Smart Contract Audit",
    category: "Web3",
    image: "images/works/ab.png",
  },
  {
    id: 10,
    title: "Application Management + Migration",
    category: "Cloud Architecture",
    image: "images/works/ab.png",
  },
];

function Works() {
  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(3);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    setActiveFilter(filters[0].text.toLowerCase());
    setVisibleItems(getAllItems.filter((item) => item.id <= 3));
  }, [getAllItems]);

  const handleChange = (e) => {
    e.preventDefault();
    setActiveFilter(e.target.textContent.toLowerCase());
    let tempData;
    if (e.target.textContent.toLowerCase() === filters[0].text.toLowerCase()) {
      tempData = getAllItems.filter((data) => data.id <= dataVisibleCount);
      console.log(tempData)
    } else {
      tempData = getAllItems.filter(
        (data) =>
          data.category === e.target.textContent &&
          data.id <= dataVisibleCount
      );
      console.log(tempData)
    }
    setVisibleItems(tempData);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;
    if (dataVisibleCount > getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      if (activeFilter === filters[0].text.toLowerCase()) {
        // console.log("they are same");
        setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
      } else {
        setVisibleItems(
          getAllItems.filter(
            (data) => data.category === activeFilter && data.id <= tempCount
          )
        );
      }
    }
  };

  return (
    <section id="works">
      <div className="container">
        <PageTitle title="Recent Works" />
        {/* Start Portfolio Filters */}
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          animateOnce={true}
        >
          <ul className="portfolio-filter list-inline">
            {filters.map((filter) => (
              <li className="list-inline-item" key={filter.id}>
                <button
                  onClick={handleChange}
                  className={
                    filter.text.toLowerCase() === activeFilter
                      ? "text-capitalize current"
                      : "text-capitalize"
                  }
                >
                  {filter.text}
                </button>
              </li>
            ))}
          </ul>
        </ScrollAnimation>
        {/* End Portfolio Filters */}

        {/* Start Portfolio Items */}
        <div className="row portfolio-wrapper">
          {visibleItems.map((item) => (
            <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
              <Portfolio portfolio={item} />
            </div>
          ))}
        </div>
        {/* End Portfolio Items */}

        <div className="load-more text-center mt-4">
          <button
            className="btn btn-default"
            onClick={handleLoadmore}
            disabled={noMorePost ? "disabled" : null}
          >
            {noMorePost ? (
              "No more items"
            ) : (
              <span>
                <i className="fas fa-spinner"></i> Load more
              </span>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Works;
